module.exports = __webpack_public_path__ + "img/groupWhite.6af32082.svg";